import "../Styles/DefaultAvatar.css";
import { formatInitials } from "../utils/format";

type DefaultAvatarProps = {
  name: string;
  avatarUrl?: string;
  onClick?: () => void;
};

export default function DefaultAvatar({ name, avatarUrl, onClick }: DefaultAvatarProps) {
  const Wrapper: any = onClick ? "button" : "div";

  return (
    <Wrapper
      type={onClick ? "button" : undefined}
      className="default-avatar"
      onClick={onClick}
      aria-label={onClick ? "Open menu" : undefined}
    >
      {avatarUrl ? (
        <img className="card-avatar" src={avatarUrl} alt={`${name} avatar`} />
      ) : (
        <p>{formatInitials(name)}</p>
      )}
    </Wrapper>
  );
}
